/* JOIEX v5 hero — sparkles canvas, pointer parallax and the WCAG 2.2.2
   pause/play toggle for sections/image-banner.liquid.
   API: window.JXHero.init(el) / window.JXHero.destroy(el).
   Toggle labels come from data-label-pause / data-label-play (Liquid | t). */
(function () {
  'use strict';
  if (window.JXHero) return;

  var KEY = 'joiex_motion';
  var CREAM = '#FFF4E0';
  var BOKEH = '#C2485C';
  var LIGHT = { c1: '#B8843F', cream: '#C98E62', c2: '#A8354A', bokeh: '#D9899A' };
  var TAU = Math.PI * 2;
  var MOBILE_MAX = 989;
  var live = [];
  var spriteCache = {};

  var ICONS =
    '<svg class="hero-motion-pause" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<rect x="3.5" y="2.5" width="3" height="11" rx="1" fill="currentColor"/>' +
    '<rect x="9.5" y="2.5" width="3" height="11" rx="1" fill="currentColor"/></svg>' +
    '<svg class="hero-motion-play" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<path d="M4.5 2.9v10.2c0 .7.8 1.1 1.4.7l7.6-5.1c.5-.4.5-1.1 0-1.4L5.9 2.2c-.6-.4-1.4 0-1.4.7z" fill="currentColor"/></svg>';

  function media(q) { return window.matchMedia ? window.matchMedia(q) : null; }
  var mqReduce = media('(prefers-reduced-motion: reduce)');
  var mqFine = media('(hover: hover) and (pointer: fine)');

  function prefersReduced() { return !!(mqReduce && mqReduce.matches); }
  function isMobile() { return window.innerWidth <= MOBILE_MAX; }
  function listen(m, fn) {
    if (!m) return;
    if (m.addEventListener) m.addEventListener('change', fn); else if (m.addListener) m.addListener(fn);
  }
  function unlisten(m, fn) {
    if (!m) return;
    if (m.removeEventListener) m.removeEventListener('change', fn); else if (m.removeListener) m.removeListener(fn);
  }

  function readPref() {
    try { return window.localStorage.getItem(KEY); } catch (e) { return null; }
  }
  function writePref(paused) {
    try {
      if (paused) window.localStorage.setItem(KEY, 'paused');
      else window.localStorage.removeItem(KEY);
    } catch (e) { /* storage blocked: the choice lasts for this page view */ }
  }

  function lowEnd() {
    var n = navigator, c = n.connection;
    return !!((c && c.saveData) ||
      (n.deviceMemory && n.deviceMemory <= 4) ||
      (n.hardwareConcurrency && n.hardwareConcurrency <= 4));
  }

  function toRgb(value, fallback) {
    var s = String(value || '').trim(), m = /rgba?\(([^)]+)\)/i.exec(s);
    if (m) {
      var p = m[1].split(/[\s,\/]+/);
      if (p.length >= 3) return [parseFloat(p[0]) | 0, parseFloat(p[1]) | 0, parseFloat(p[2]) | 0];
    }
    var h = s.replace('#', '');
    if (h.length === 3) h = h.charAt(0) + h.charAt(0) + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2);
    var v = parseInt(h, 16);
    if (h.length !== 6 || isNaN(v)) return fallback ? toRgb(fallback) : [243, 217, 164];
    return [(v >> 16) & 255, (v >> 8) & 255, v & 255];
  }

  /* 64px sprites, rendered once per kind + colour and shared by every hero */
  function sprite(kind, color) {
    var key = kind + '|' + color;
    if (spriteCache[key]) return spriteCache[key];
    var cv = document.createElement('canvas');
    cv.width = cv.height = 64;
    var g = cv.getContext('2d'), k = toRgb(color), gr, i;
    var col = function (a) { return 'rgba(' + k[0] + ',' + k[1] + ',' + k[2] + ',' + a + ')'; };
    if (kind === 'star') {
      g.translate(32, 32);
      gr = g.createRadialGradient(0, 0, 0, 0, 0, 13);
      gr.addColorStop(0, col(0.85));
      gr.addColorStop(1, col(0));
      g.fillStyle = gr;
      g.beginPath(); g.arc(0, 0, 13, 0, TAU); g.fill();
      for (i = 0; i < 2; i++) {
        g.save();
        g.rotate(i * Math.PI / 2);
        gr = g.createLinearGradient(-32, 0, 32, 0);
        gr.addColorStop(0, col(0));
        gr.addColorStop(0.5, col(1));
        gr.addColorStop(1, col(0));
        g.fillStyle = gr;
        g.beginPath();
        g.moveTo(-32, 0);
        g.quadraticCurveTo(0, -3.2, 32, 0);
        g.quadraticCurveTo(0, 3.2, -32, 0);
        g.fill();
        g.restore();
      }
      g.fillStyle = 'rgba(255,244,224,1)';
      g.beginPath(); g.arc(0, 0, 2.4, 0, TAU); g.fill();
    } else {
      gr = g.createRadialGradient(32, 32, 0, 32, 32, 32);
      if (kind === 'bokeh') {
        gr.addColorStop(0, col(0.9));
        gr.addColorStop(0.55, col(0.55));
        gr.addColorStop(1, col(0));
      } else {
        gr.addColorStop(0, col(1));
        gr.addColorStop(0.22, col(0.85));
        gr.addColorStop(0.55, col(0.2));
        gr.addColorStop(1, col(0));
      }
      g.fillStyle = gr;
      g.fillRect(0, 0, 64, 64);
    }
    spriteCache[key] = cv;
    return cv;
  }

  function Hero(el) {
    var s = this;
    s.el = el;
    s.canvas = el.querySelector('[data-hero-canvas]');
    s.ctx = s.canvas && s.canvas.getContext ? s.canvas.getContext('2d') : null;
    if (!s.ctx) s.canvas = null;
    s.copyEl = el.querySelector('[data-hero-copy]');
    s.stageEl = el.querySelector('.hero-stage');
    s.parEl = el.querySelector('[data-hero-parallax]');
    s.photo = el.getAttribute('data-mode') === 'photo';
    s.floating = el.getAttribute('data-float') === 'true' && !!el.querySelector('.hero-float');
    s.wantParallax = el.getAttribute('data-parallax') === 'true' && !!s.parEl;
    s.base = parseFloat(el.getAttribute('data-count')) || 80;

    s.paint();

    s.parts = [];
    s.w = 0; s.h = 0;
    s.copy = null; s.stage = null;
    s.clock = 0; s.last = 0; s.raf = 0; s.frames = 0;
    s.running = false;
    s.inView = true;
    s.reduced = prefersReduced();
    s.userPaused = readPref() === 'paused';
    s.px = 0; s.py = 0; s.tx = 0; s.ty = 0;
    s.parOn = false; s.parWritten = '';
    s.nextFlash = 0; s.flash = null;
    s.perfN = 0; s.perfSum = 0; s.perfDone = false; s.perfScale = 1;
    s.low = lowEnd();

    s.frame = function (now) { s.tick(now); };
    s.onToggle = function () { setAllPaused(!s.userPaused); };
    s.onVis = function () { s.update(); };
    s.onReduce = function () {
      s.reduced = prefersReduced();
      s.syncToggle();
      s.measure();
      s.update();
    };
    s.onFine = function () { s.measure(); s.update(); };
    s.onMove = function (e) {
      if (!s.parOn || e.pointerType === 'touch') return;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return;
      s.tx = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width) * 2 - 1));
      s.ty = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height) * 2 - 1));
      s.kick();
    };
    s.onLeave = function () { s.tx = 0; s.ty = 0; s.kick(); };

    el.addEventListener('pointermove', s.onMove, { passive: true });
    el.addEventListener('pointerleave', s.onLeave);
    document.addEventListener('visibilitychange', s.onVis);
    listen(mqReduce, s.onReduce);
    listen(mqFine, s.onFine);

    if ('ResizeObserver' in window) {
      s.ro = new ResizeObserver(function () {
        if (!s.el) return;
        s.measure();
        s.update();
      });
      s.ro.observe(el);
      if (s.copyEl) s.ro.observe(s.copyEl);
    } else {
      s.onResize = function () { s.measure(); s.update(); };
      window.addEventListener('resize', s.onResize);
    }

    if ('IntersectionObserver' in window) {
      s.io = new IntersectionObserver(function (entries) {
        if (!s.el) return;
        s.inView = entries[entries.length - 1].isIntersecting;
        s.update();
      }, { rootMargin: '100px 0px' });
      s.io.observe(el);
    }

    s.measure();
    s.syncToggle();
    s.update();
  }

  /* sprites for the current colour mode (v7): additive light vanishes on the
     light hero, so there the specks turn gold / claret and paint normally */
  Hero.prototype.paint = function () {
    var s = this, el = s.el;
    if (!s.canvas) return;
    s.light = document.documentElement.getAttribute('data-theme') === 'light';
    var c1 = s.light ? (el.getAttribute('data-c1-light') || LIGHT.c1) : (el.getAttribute('data-c1') || '#F3D9A4');
    var c2 = s.light ? (el.getAttribute('data-c2-light') || LIGHT.c2) : (el.getAttribute('data-c2') || '#E8C4B8');
    var cr = s.light ? LIGHT.cream : CREAM;
    s.spr = [
      [sprite('dot', c1), sprite('dot', cr), sprite('dot', c2)],
      [sprite('star', c1), sprite('star', cr), sprite('star', c2)],
      [sprite('bokeh', s.light ? LIGHT.bokeh : BOKEH)]
    ];
  };

  Hero.prototype.hasMotion = function () {
    return !!(this.canvas || this.floating);
  };

  Hero.prototype.syncToggle = function () {
    var s = this, el = s.el;
    if (!s.hasMotion() || s.reduced) {
      if (s.btn) {
        s.btn.removeEventListener('click', s.onToggle);
        if (s.btn.parentNode) s.btn.parentNode.removeChild(s.btn);
        s.btn = null;
      }
      return;
    }
    if (!s.btn) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hero-motion';
      b.setAttribute('data-hero-motion', '');
      b.innerHTML = ICONS;
      b.addEventListener('click', s.onToggle);
      el.appendChild(b);
      s.btn = b;
    }
    var label = el.getAttribute(s.userPaused ? 'data-label-play' : 'data-label-pause') || '';
    s.btn.setAttribute('aria-pressed', s.userPaused ? 'true' : 'false');
    if (label) {
      s.btn.setAttribute('aria-label', label);
      s.btn.setAttribute('title', label);
    }
  };

  Hero.prototype.update = function () {
    var s = this;
    if (!s.el) return;
    var paused = s.userPaused && s.hasMotion();
    var run = !paused && s.inView && !document.hidden && !s.reduced;
    s.el.classList.toggle('is-paused', !run);
    if (run) s.start(); else s.stop();
  };

  Hero.prototype.start = function () {
    var s = this;
    if (!s.running) {
      s.running = true;
      s.last = performance.now();
    }
    s.kick();
  };

  Hero.prototype.kick = function () {
    var s = this;
    if (s.running && !s.raf && (s.canvas || s.parOn)) {
      s.last = performance.now();
      s.raf = requestAnimationFrame(s.frame);
    }
  };

  Hero.prototype.stop = function () {
    var s = this;
    if (s.raf) {
      cancelAnimationFrame(s.raf);
      s.raf = 0;
    }
    s.running = false;
    /* user pause and reduced motion leave one clean static frame */
    if (s.canvas && (s.reduced || s.userPaused)) {
      s.flash = null;
      s.draw(false);
    }
  };

  Hero.prototype.tick = function (now) {
    var s = this;
    s.raf = 0;
    if (!s.running || !s.el) return;
    var raw = now - s.last;
    s.last = now;
    var dt = Math.min(Math.max(raw, 0), 50) / 1000;
    s.clock += dt;
    s.frames++;

    /* adaptive quality: halve once if the first 60 measured frames average > 24ms */
    if (s.canvas && !s.perfDone && s.frames > 5) {
      if (raw > 0 && raw < 250) { s.perfSum += raw; s.perfN++; }
      if (s.perfN >= 60) {
        s.perfDone = true;
        if (s.perfSum / s.perfN > 24) {
          s.perfScale = 0.5;
          s.fit();
        }
      }
    }

    var settled = true;
    /* frozen while the product is in flight (v6-motion.js), so the hand-back never jumps */
    if (s.parOn && !s.el.classList.contains('jx-flying')) {
      var k = 1 - Math.pow(1 - 0.06, dt * 60);
      s.px += (s.tx - s.px) * k;
      s.py += (s.ty - s.py) * k;
      if (Math.abs(s.tx - s.px) > 0.001 || Math.abs(s.ty - s.py) > 0.001) settled = false;
      else { s.px = s.tx; s.py = s.ty; }
      s.writeParallax();
    }

    if (s.canvas) {
      s.step(dt);
      s.draw(true);
    }
    if (s.canvas || !settled) s.raf = requestAnimationFrame(s.frame);
  };

  Hero.prototype.writeParallax = function () {
    var s = this;
    var v = 'translate3d(' + (-10 * s.px).toFixed(2) + 'px,' + (-8 * s.py).toFixed(2) + 'px,0)';
    if (v !== s.parWritten) {
      s.parEl.style.transform = v;
      s.parWritten = v;
    }
  };

  Hero.prototype.measure = function () {
    var s = this, el = s.el;
    if (!el) return;
    var r = el.getBoundingClientRect();
    var w = Math.max(1, Math.round(r.width));
    var h = Math.max(1, Math.round(r.height));
    var mobile = isMobile();

    var par = s.wantParallax && !mobile && !s.reduced && !!(mqFine && mqFine.matches);
    if (!par && s.parEl && (s.parOn || s.parWritten)) {
      s.px = s.py = s.tx = s.ty = 0;
      s.parEl.style.transform = '';
      s.parWritten = '';
    }
    s.parOn = par;
    if (s.parEl) s.parEl.style.willChange = par ? 'transform' : '';

    if (!s.canvas) return;

    var dpr = Math.min(window.devicePixelRatio || 1, mobile ? 1.5 : 2);
    var cw = Math.round(w * dpr), ch = Math.round(h * dpr), i;
    if (s.w && (s.w !== w || s.h !== h)) {
      var fx = w / s.w, fy = h / s.h;
      for (i = 0; i < s.parts.length; i++) {
        s.parts[i].x *= fx;
        s.parts[i].y *= fy;
      }
    }
    s.w = w;
    s.h = h;
    if (s.canvas.width !== cw || s.canvas.height !== ch) {
      s.canvas.width = cw;
      s.canvas.height = ch;
    }
    s.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var pad = 8, c;
    if (s.copyEl && (c = s.copyEl.getBoundingClientRect()).width) {
      s.copy = { l: c.left - r.left - pad, t: c.top - r.top - pad, r: c.right - r.left + pad, b: c.bottom - r.top + pad };
    } else {
      s.copy = null;
    }
    if (s.stageEl && (c = s.stageEl.getBoundingClientRect()).width) {
      s.stage = {
        cx: c.left - r.left + c.width / 2,
        cy: c.top - r.top + c.height / 2,
        rx: Math.max(c.width * 0.62, 90),
        ry: Math.max(c.height * 0.5, 90)
      };
    } else {
      s.stage = null;
    }

    s.fit();
    if (!s.running) s.draw(false);
  };

  Hero.prototype.fit = function () {
    var s = this;
    var n = s.base * Math.min(1.2, Math.max(0.35, (s.w * s.h) / (1440 * 800)));
    if (s.low) n *= 0.5;
    if (s.photo) n *= 0.5;
    n *= s.perfScale;
    if (isMobile()) n = Math.min(n, 48);
    n = Math.max(0, Math.round(n));
    while (s.parts.length < n) s.parts.push(s.spawn({}, false));
    if (s.parts.length > n) s.parts.length = n;
    if (s.flash && s.parts.indexOf(s.flash.p) < 0) s.flash = null;
  };

  /* 72% dots, 22% stars, 6% bokeh; colours c1 .50 / cream .25 / c2 .17 (bokeh is claret) */
  Hero.prototype.spawn = function (p, below) {
    var r = Math.random(), z = 0.35 + Math.random() * 0.65, w;
    p.k = r < 0.72 ? 0 : (r < 0.94 ? 1 : 2);
    p.z = z;
    if (p.k === 0) {
      p.half = (0.6 + Math.random() * 1.6) * z * 2.6;
      p.base = 0.35 + Math.random() * 0.6;
      p.pow = 1.5;
    } else if (p.k === 1) {
      p.half = (3 + Math.random() * 4) * z;
      p.base = 0.35 + Math.random() * 0.6;
      p.pow = 3;
    } else {
      p.half = (8 + Math.random() * 8) * z * 0.7;
      p.base = 0.1 + Math.random() * 0.15;
      p.pow = 1;
    }
    if (p.k === 2) {
      p.c = 0;
    } else {
      w = Math.random();
      p.c = w < 0.5435 ? 0 : (w < 0.8152 ? 1 : 2);
    }
    p.vy = -(6 + Math.random() * 12) * z;
    p.amp = 4 + Math.random() * 10;
    p.f = 0.15 + Math.random() * 0.2;
    p.ph = Math.random() * TAU;
    p.f2 = 0.2 + Math.random() * 0.7;
    p.ph2 = Math.random() * TAU;
    this.place(p, below);
    return p;
  };

  /* 60% in an ellipse around the product stage, 40% anywhere */
  Hero.prototype.place = function (p, below) {
    var s = this, st = s.stage;
    if (st && Math.random() < 0.6) {
      var a = Math.random() * TAU, d = Math.sqrt(Math.random());
      p.x = st.cx + Math.cos(a) * d * st.rx;
      p.y = st.cy + Math.sin(a) * d * st.ry;
    } else {
      p.x = Math.random() * s.w;
      p.y = Math.random() * s.h;
    }
    if (below) p.y = s.h + p.half + Math.random() * 40;
  };

  Hero.prototype.step = function (dt) {
    var ps = this.parts;
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      p.y += p.vy * dt;
      if (p.y < -p.half - 24) this.spawn(p, true);
    }
  };

  Hero.prototype.inCopy = function (x, y, pad) {
    var c = this.copy;
    return !!c && x > c.l - pad && x < c.r + pad && y > c.t - pad && y < c.b + pad;
  };

  Hero.prototype.draw = function (animated) {
    var s = this, g = s.ctx;
    if (!g || !s.w) return;
    var t = s.clock, ps = s.parts, spr = s.spr;
    var mul = (s.reduced ? 0.7 : 1) * (s.light ? 0.85 : 1);
    var ox = s.parOn ? -s.px * 18 : 0;
    var oy = s.parOn ? -s.py * 18 : 0;
    g.clearRect(0, 0, s.w, s.h);
    g.globalCompositeOperation = s.light ? 'source-over' : 'lighter';
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i], hh = p.half;
      var x = p.x + Math.sin(TAU * p.f * t + p.ph) * p.amp + ox * p.z;
      var y = p.y + oy * p.z;
      if (x < -hh || x > s.w + hh || y < -hh || y > s.h + hh) continue;
      var a = p.base * (0.25 + 0.75 * Math.pow(0.5 + 0.5 * Math.sin(TAU * p.f2 * t + p.ph2), p.pow));
      if (s.inCopy(x, y, p.k === 0 ? 0 : hh)) {
        if (p.k !== 0) continue; /* no stars or bokeh behind text */
        a *= 0.15;
      }
      if (y < 60) a *= Math.max(0, y / 60);
      a *= mul;
      if (a < 0.01) continue;
      g.globalAlpha = a > 1 ? 1 : a;
      g.drawImage(spr[p.k][p.c], x - hh, y - hh, hh * 2, hh * 2);
    }
    if (animated) s.flashes(g, t, ox, oy);
    g.globalAlpha = 1;
    g.globalCompositeOperation = 'source-over';
  };

  /* every 900-1800ms one star outside the copy scales 0 → 1.8 → 0 over 700ms */
  Hero.prototype.flashes = function (g, t, ox, oy) {
    var s = this, ms = t * 1000, p, tries;
    if (!s.flash && ms >= s.nextFlash && s.parts.length) {
      s.nextFlash = ms + 900 + Math.random() * 900;
      for (tries = 0; tries < 10; tries++) {
        p = s.parts[(Math.random() * s.parts.length) | 0];
        if (p && p.k === 1 && !s.inCopy(p.x, p.y, p.half * 2)) {
          s.flash = { p: p, t0: t };
          break;
        }
      }
    }
    var f = s.flash;
    if (!f) return;
    var ph = (t - f.t0) / 0.7;
    if (ph < 0 || ph >= 1) {
      s.flash = null;
      return;
    }
    p = f.p;
    var x = p.x + Math.sin(TAU * p.f * t + p.ph) * p.amp + ox * p.z;
    var y = p.y + oy * p.z;
    var hh = p.half * 1.8 * Math.sin(Math.PI * ph);
    if (hh < 0.5 || s.inCopy(x, y, hh)) return;
    g.globalAlpha = 1;
    g.drawImage(s.spr[1][1], x - hh, y - hh, hh * 2, hh * 2);
  };

  Hero.prototype.destroy = function () {
    var s = this, el = s.el;
    if (!el) return;
    if (s.raf) cancelAnimationFrame(s.raf);
    s.raf = 0;
    s.running = false;
    if (s.io) s.io.disconnect();
    if (s.ro) s.ro.disconnect();
    if (s.onResize) window.removeEventListener('resize', s.onResize);
    el.removeEventListener('pointermove', s.onMove);
    el.removeEventListener('pointerleave', s.onLeave);
    document.removeEventListener('visibilitychange', s.onVis);
    unlisten(mqReduce, s.onReduce);
    unlisten(mqFine, s.onFine);
    if (s.btn) {
      s.btn.removeEventListener('click', s.onToggle);
      if (s.btn.parentNode) s.btn.parentNode.removeChild(s.btn);
      s.btn = null;
    }
    if (s.parEl) {
      s.parEl.style.transform = '';
      s.parEl.style.willChange = '';
    }
    if (s.ctx && s.w) s.ctx.clearRect(0, 0, s.w, s.h);
    el.classList.remove('is-paused');
    s.parts = [];
    s.flash = null;
    s.el = null;
  };

  function setAllPaused(paused) {
    writePref(paused);
    /* the same choice stills the looping stage and band animations (v7-modes.css) */
    document.documentElement.classList.toggle('jx-motion-paused', !!paused);
    for (var i = 0; i < live.length; i++) {
      live[i].userPaused = paused;
      live[i].syncToggle();
      live[i].update();
    }
  }

  function init(el) {
    if (!el) return null;
    if (el.__jxHero) return el.__jxHero;
    var hero = new Hero(el);
    el.__jxHero = hero;
    live.push(hero);
    return hero;
  }

  function destroy(el) {
    var hero = el && el.__jxHero;
    if (!hero) return;
    hero.destroy();
    el.__jxHero = null;
    var i = live.indexOf(hero);
    if (i > -1) live.splice(i, 1);
  }

  function each(root, fn) {
    if (!root) return;
    if (root.matches && root.matches('[data-hero]')) fn(root);
    var list = root.querySelectorAll ? root.querySelectorAll('[data-hero]') : [];
    for (var i = 0; i < list.length; i++) fn(list[i]);
  }

  function boot() { each(document, init); }

  /* a saved pause stops the CSS float immediately, before the idle init */
  function prime() {
    if (readPref() !== 'paused') return;
    document.documentElement.classList.add('jx-motion-paused');
    if (prefersReduced()) return;
    each(document, function (el) {
      if (el.getAttribute('data-float') === 'true' || el.querySelector('[data-hero-canvas]')) el.classList.add('is-paused');
    });
  }

  function schedule() {
    var go = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(boot, { timeout: 2000 });
      else window.setTimeout(boot, 1200);
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  document.addEventListener('shopify:section:load', function (e) { each(e.target, init); });
  document.addEventListener('shopify:section:unload', function (e) { each(e.target, destroy); });

  /* v7 colour modes: repaint the sprites for the new mode */
  document.addEventListener('joiex:themechange', function () {
    for (var i = 0; i < live.length; i++) {
      if (!live[i].canvas) continue;
      live[i].paint();
      if (!live[i].running) live[i].draw(false);
    }
  });

  window.JXHero = { init: init, destroy: destroy };
  prime();
  schedule();
})();
